import { api } from "@/lib/api";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

const toKey = (b64) => {
  const pad = "=".repeat((4 - (b64.length % 4)) % 4);
  const raw = atob((b64 + pad).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

const registration = async () => (await navigator.serviceWorker.getRegistration()) || navigator.serviceWorker.register("/sw.js");

export const currentSubscription = async () => {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.getRegistration();
  return reg ? reg.pushManager.getSubscription() : null;
};

// Asks permission, subscribes this device and saves it via `save(subscription)`. Returns the permission result.
export const enablePush = async (save = (sub) => api.post("/push/subscribe", { subscription: sub, timezone: Intl.DateTimeFormat().resolvedOptions().timeZone })) => {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") return perm;
  const reg = await registration();
  await navigator.serviceWorker.ready;
  const { data } = await api.get("/push/public-key");
  const sub = (await reg.pushManager.getSubscription())
    || (await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toKey(data.key) }));
  await save(sub.toJSON());
  return perm;
};

export const disablePush = async (path = "/push/unsubscribe") => {
  const sub = await currentSubscription();
  if (!sub) return;
  await api.post(path, { endpoint: sub.endpoint });
  await sub.unsubscribe();
};
